import * as types from "./searchActionTypes";
import initialState from "./searchInitialState";
import { MINIMUM_QUERY_LENGTH } from "./enums/searchBoxSettings";

export default function searchReducer(state = initialState.search, action) {
  switch (action.type) {
    case types.SEARCH_CLEAR_RESULTS: {
      return initialState.search;
    }

    case types.SEARCH_CLIENTS: {
      const clients = {
        ...state.clients,
        sortBy: action.sortBy,
        fetching: true,
      };
      return { ...state, clients };
    }
    case types.SEARCH_CLIENTS_SUCCESS: {
      const data = action.payload.data.data.clientsFts || {};

      const clients = {
        ...state.clients,
        items: data.items,
        pagination: {
          offset: data.offset,
          limit: data.limit,
          count: data.count,
          totalCount: data.totalCount
        },
        fetching: false,
      };
      return { ...state, clients };
    }

    case types.SEARCH_MEMBERS: {
      const members = {
        ...state.members,
        sortBy: action.sortBy,
        fetching: true,
      };
      return { ...state, members };
    }
    case types.SEARCH_MEMBERS_SUCCESS: {
      const data = action.payload.data.data.membersClientFts || {};

      const members = {
        ...state.members,
        items: data.items,
        pagination: {
          offset: data.offset,
          limit: data.limit,
          count: data.count,
          totalCount: data.totalCount
        },
        fetching: false,
      };
      return { ...state, members };
    }

    case types.SEARCH_UPDATE_SEARCH: {
      return {
        ...state,
        searchString: action.searchString,
        showResults:
          action.searchString.length < MINIMUM_QUERY_LENGTH
            ? false
            : state.showResults || action.searchString.length > 2,
      };
    }

    case types.SEARCH_FORCE_OPEN: {
      return { ...state, showResults: true };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/search/searchReducer.js